import React, { useState } from "react";
//import { useSelector, useDispatch } from "react-redux"; //remove
//import {
//  toogleHasLogo,
  //setLogoUrl,
 // setTitlePosition,
 // setPageOption,
 // setCompleteMessage,
 /// setRedirectUrl,
//} from "../../../../../features/survey";
import { useEyeconxStore } from "../../../../store/eyeconxStore";
const SurveyProperties = () => {
  const {survey,titlePos,logoPos,toogleHasLogo,setLogoUrl,setTitlePosition,setPageOption,setCompleteMessage,setRedirectUrl} = useEyeconxStore()
  //const survey = useSelector((state) => state.survey);
  //const dispatch = useDispatch();
  //    const [titlePos,setTitlePos] = useState(survey.titlePosition)
  //const titlePos = survey.setTitlePosition;
  //const [logoPos,setLogoPos] = useState(survey.logoPosition)
  //const logoPos = survey.logoPosition;
  //const [hasLogo,setHasLogo] = useState(survey.hasLogo)

  const handleTitlePos = (e) => setTitlePosition(e.target.value);
  const handleHasLogo = (e) => toogleHasLogo(e.target.checked);
  const handleLogoUrl = (e) => setLogoUrl(e.target.value);
  const handlePageOption = (e) => setPageOption(e.target.value);
  const handleCompleteMessage = (e) =>
    setCompleteMessage(e.target.value);
  const handleRedirectUrl = (e) => setRedirectUrl(e.target.value);
  
  return (
    <>
      <form className="g-3 mt-3">
        <div className="form-group">
          <label htmlFor="titleposition">Title & Description Position</label>
          <select
            name="titleposition"
            defaultValue={titlePos}
            onChange={(e) => handleTitlePos(e)}
            id="titleposition"
            className="form-control"
          >
            <option value="left">Left</option>
            <option value="center">Center</option>
            <option value="right">Right</option>
          </select>
        </div>

        <div className="form-group form-check">
          <input
            type="checkbox"
            id="check1"
            onClick={(e) => handleHasLogo(e)}
            className="form-check-input"
          />
          <label htmlFor="check1" className="form-check-label">
            Has Logo
          </label>
        </div>

        {survey.hasLogo && (
          <div className="bg-light bg-secondary mb-2 p-2">
            <div className="form-group">
              <label htmlFor="logourl" className="mb-2 mt-2">
                Logo Url
              </label>
              <input
                type="text"
                onChange={(e) => handleLogoUrl(e)}
                className="form-control form-control-sm"
              />
            </div>
            <div className="form-group mt-2">
              <label htmlFor="logoposition">Logo Position</label>
              <select
                name="logoposition"
                defaultValue={logoPos}
                id="logoposition"
                className="form-control"
              >
                <option value="left">Left</option>
                <option value="center">Center</option>
                <option value="right">Right</option>
              </select>
            </div>
            {/*  <div className="col-12 mt-2">
                                <label htmlFor="logowidth" className="form-label form-label-sm text-seondary">Width</label>
                                <input type="text" className="form-control form-control-sm" />
                            </div>
                            <div className="col-12 mb-4 mt-2">
                                <label htmlFor="logoheight" className="form-label form-label-sm text-seondary">Height</label>
                                <input type="text" className="form-control form-control-sm" />
                             </div> */}
          </div>
        )}

        <div className="form-group">
          <label htmlFor="questionpagi" className="mb-2">
            Paging Option
          </label>
          <select
            name="titleposition"
            defaultValue={survey.pageOption}
            onChange={(e) => handlePageOption(e)}
            id="titleposition"
            className="form-control"
          >
            <option value="all">All Questions on Single Page</option>
            <option value="one">1 Question Per Page</option>
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="surveycomplete" className="mb-2">
            Survey Complete Message
          </label>
          <input
            type="text"
            onChange={(e) => handleCompleteMessage(e)}
            className="form-control form-control-sm"
          />
        </div>

        <div className="form-group">
          <label htmlFor="surveycomplete" className="mb-2">
            Redirect Url After Complete
          </label>
          <input
            type="text"
            onChange={(e) => handleRedirectUrl(e)}
            className="form-control form-control-sm"
          />
        </div>
      </form>
    </>
  );
};

export default SurveyProperties;
